export default "__VITE_ASSET__BLKK7vUI__"